import { RolePermissionMapping } from '@traton/devportal-rbac-common-lib';
import { portalUser } from './roles';
import {
  portalgroupsReadPermission,
  portalgroupsCreatePermission,
  portalgroupsUpdatePermission,
  portalgroupsDeletePermission,
} from './permissions';

export const roleMapping: RolePermissionMapping = new Map([
  [
    portalUser,
    [
      portalgroupsReadPermission,
      portalgroupsCreatePermission,
      portalgroupsUpdatePermission,
      portalgroupsDeletePermission,
    ],
  ],
]);
